
import React from 'react'
import firebaseApp from '../../firebase';
import './styles/FileUpload.scss'
import AddPhotoImg from '../../images/icons/add_a_photo_black.svg'

class FileUpload extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      'progress': null,
      'done': false
    }
    this.uploadFile = this.uploadFile.bind(this)
    this.onProgress = this.onProgress.bind(this)
    this.complete = this.complete.bind(this)
    this.error = this.error.bind(this)
  }

  complete(){
    console.log('complete');
    this.setState({
      'progress': null
    })
    let urls = {}
    this.storageRef.getDownloadURL()
      .then(url => {
        urls['orig'] = url;
        this.scaleRef.getDownloadURL()
        .then(url => {
          urls['scaled'] = url;
          this.thumbRef.getDownloadURL()
          .then(url => {
            urls['thumb'] = url;
            console.log('urls:', urls);
            this.props.callback(urls)
          })
        })
      })
  }

  error(err){
    console.log(err);
  }

  onProgress(snapshot){
    let percentage = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
    this.setState({
      'progress': percentage
    })
  }

  uploadFile(file){
    const fileName = this.props.name + '_' + file.name.split('.')[0] + '_' + Date.now();
    const ext = file.name.split('.').slice(-1)[0].toLowerCase()
    const path = this.props.path
    console.log(`${path}thumb_${fileName}.${ext}`);
    console.log(`${path}${fileName}.${ext}`);
    this.storageRef = firebaseApp.storage().ref(`${path}${fileName}.${ext}`);
    this.thumbRef = firebaseApp.storage().ref(`${path}thumb_${fileName}.${ext}`);
    this.scaleRef = firebaseApp.storage().ref(`${path}scaled_${fileName}.${ext}`);

    // 1px blob
    const onePx = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    // upload a one px image for thumb and scaled to greate an image ref for the downloadURL
    this.thumbRef.putString(onePx, 'data_url').then(function(snapshot) {
      console.log('Uploaded a base64url thumb!');
    });
    this.scaleRef.putString(onePx, 'data_url').then(function(snapshot) {
      console.log('Uploaded a base64url scaled!');
    });

    // upload the image
    console.log('Upload File', file);
    const task = this.storageRef.put(file)

    task.on('state_changed', this.onProgress, this.error, this.complete)
  }

  waitFor = (image, ms) => new Promise(r => setTimeout(() => {
    this.uploadFile(image);
  }, ms));
  asyncForEach = async (array, callback) => {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array)
    }
  }

  startUpload = async (images) => {
    await this.asyncForEach(images, async (image) => {
      await this.waitFor(image, 1000);
      console.log(image);
    })
    console.log('Done');
  }

  render(){
    let {progress} = this.state;
    return (<div className="uploader">

      { progress ? <div className="progress">
        <div className="md-caption">Uploading... </div>
        <div className="bar" style={{
            width: `${progress}%`
          }
        }>{progress}%</div>
        </div>
      : <div className="upload-button">
      <img src={AddPhotoImg} alt="Add a photo" height="32" />
      <input accept="image/*" type="file" onChange={(e) => {
          console.log(e.target);
          const images = Array.from(e.target.files);
          console.log(images);
          this.startUpload(images);
        }
      } />
      </div>
    }
    </div>)
  }

}

FileUpload.defaultProps = {
  'name': null,
  'path': 'images/',
  'callback': () =>{}
}

export default FileUpload;



// WEBPACK FOOTER //
// ./src/components/ui/FileUpload.jsx